module.exports = __webpack_public_path__ + "img/user.34b16bf7.svg";